import { Box, Divider, Link as MuiLink } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ScrollSpy from 'react-scrollspy-navigation';
import { Routing } from 'shared/constants/routing';
import { Link } from 'react-router-dom';

interface IHeaderDrawerProps {
    handleDrawerToggle: () => void;
}

const HeaderDrawer: React.FC<IHeaderDrawerProps> = ({ handleDrawerToggle }) => {
    const history = useHistory();
    const location = useLocation();

    const handleNavClick = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        if (location.pathname === Routing.Clinicians) {
            event.preventDefault();
            history.push({ pathname: Routing.Landing, state: { id, fromDrawer: true } });
        }
    };

    return (
        <Box onClick={handleDrawerToggle}>
            <MuiLink href={Routing.Landing} title="Health Reach" className="drawer-logo-block">
                <img src={images.logo} alt="Logo" />
            </MuiLink>
            <Divider />
            <div className="drawer-block">
                <ScrollSpy key={location.pathname} offsetTop={80} duration={1500}>
                    <a
                        href="#home"
                        ref={React.createRef()}
                        onClick={(e) => handleNavClick(e, 'home')}
                        className="nav-link"
                    >
                        Home
                    </a>
                    <a
                        href="#about-us"
                        ref={React.createRef()}
                        data-to-scrollspy-id="about-us"
                        onClick={(e) => handleNavClick(e, 'about-us')}
                        className="nav-link"
                    >
                        About Us
                    </a>
                    <a
                        href="#practice-with-us"
                        ref={React.createRef()}
                        onClick={(e) => handleNavClick(e, 'practice-with-us')}
                        className="nav-link"
                    >
                        Practice With Us
                    </a>
                    <a
                        href="#access-service"
                        ref={React.createRef()}
                        onClick={(e) => handleNavClick(e, 'access-service')}
                        className="nav-link"
                    >
                        Access Clinicians
                    </a>
                    <a
                        href="#news"
                        ref={React.createRef()}
                        onClick={(e) => handleNavClick(e, 'news')}
                        className="nav-link"
                    >
                        Health News
                    </a>
                    <a
                        href="#faq"
                        ref={React.createRef()}
                        onClick={(e) => handleNavClick(e, 'faq')}
                        className="nav-link"
                    >
                        FAQ
                    </a>
                </ScrollSpy>

                <Link
                    to={Routing.Clinicians}
                    className={`nav-link ${location.pathname === Routing.Clinicians ? 'active' : ''}`}
                >
                    Clinicians
                </Link>
            </div>
        </Box>
    );
};

export default HeaderDrawer;
